module.exports = __webpack_public_path__ + "img/qlc.4fa6210d.svg";